import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  addRoleHref: string;
};

/**
 * {@link EmptyRoles} is an empty state for the roles page, giving the user a CTA to add a role.
 */
export function EmptyRoles({ addRoleHref }: Props) {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3">You don’t have any roles set up</h2>
        <p className="p-lt mb-24">
          <a className="a" href="https://www.defined.net/docs/glossary/role/" target="_blank" rel="help">
            Roles
          </a>{' '}
          are identities which hosts, lighthouses, and relays use to organize and manage firewall rules between
          different kinds of machines.
        </p>
        <LinkButton to={addRoleHref}>Create role</LinkButton>
      </div>
    </CenteredLayout>
  );
}
